<template>
  <div class="page-content realNameAuth" :style="defaultHeight">
    <div class="startTitle">实名认证</div>
    <el-row style="margin-top: 50px">
      <el-col :span="14" :offset="5">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="真实姓名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="idType">
            <el-select v-model="ruleForm.idType" placeholder="请选择" style="width: 170px">
              <el-option label="身份证" :value="1"></el-option>
              <el-option label="军官证" :value="2"></el-option>
              <el-option label="台胞证" :value="3"></el-option>
              <el-option label="护照" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="idNumber">
            <el-input v-model="ruleForm.idNumber"></el-input>
          </el-form-item>
          <el-form-item class="idImgBox" label="证件照片" required style="margin-bottom: 0">
            <el-col :span="11">
              <el-form-item prop="credenPhotofront">
                <div class="credenPhoto">

                  <el-upload class="btn-plus" :action="imgAction" :http-request="front_uploadImg" name="img" :multiple="false" :show-file-list="false" :on-success="front_handleSuccess" :before-upload="beforeUpload">
                    <img v-if="ruleForm.credenPhotofront" :src="ruleForm.credenPhotofront" class="imgsrcval">
                    <div v-else>
                      <img src="../../assets/images/back/credenPhotofront.png" alt="">
                      <el-button icon="el-icon-plus" circle></el-button>
                    </div>
                    <p class="idbottom_Text">上传身份证人像面</p>
                  </el-upload>

                </div>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2" style="color: #ffffff">-</el-col>
            <el-col :span="11">
              <el-form-item prop="credenPhotoback">
                <div class="credenPhoto">
                  <el-upload class="btn-plus" :action="imgAction" :http-request="back_uploadImg" name="img" :multiple="false" :show-file-list="false" :on-success="back_handleSuccess" :before-upload="beforeUpload">
                    <img v-if="ruleForm.credenPhotoback" :src="ruleForm.credenPhotoback" class="imgsrcval">
                    <div v-else>
                      <img src="../../assets/images/back/credenPhotoback.png" alt="">
                      <el-button icon="el-icon-plus" circle></el-button>

                    </div>
                    <p class="idbottom_Text">上传身份证国徽面</p>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-form-item>
          <div class="el-upload__tip" style="padding-left: 100px;padding-top: 30px;padding-bottom: 10px">请使用jpg格式照片，大小不超过5M</div>
          <el-form-item>
            <el-button type="success" class="btn-save dmh-colbtn" @click="submitForm('ruleForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import { Notification } from 'element-ui'
import Cookies from 'js-cookie'
import { professionalQueryRealById, professionalSaveRealName, uploadImg } from '@/api/myInfo'
import baseAPI from "@/api/baseAPI";
export default {
  name: "realNameAuth",
  data () {
    let idCardValidity = (rule, code, callback) => {
      var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
      var tip = ""
      var pass = true
 
      if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "身份证号格式错误"
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = "地址编码错误"
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length === 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          var last = parity[sum % 11];
          if (parity[sum % 11] != code[17]) {
            tip = "校验位错误"
            pass = false
          }
        }
      }
      if (!pass) {
        callback(new Error(tip))
      } else {
        callback()
      }
      // if (!pass) alert(tip)
      // return pass
    }
    return {
      defaultHeight: {
        height: ""
      },
      //图片列表（用于在上传组件中回显图片）
      fileList: [],
      // 图片上传地址
      imgAction: null,
      ruleForm: {
        userId: '',
        name: '',
        idType: '',
        idNumber: '',
        credenPhotofront: '',
        credenPhotoback: '',

      },
      rules: {
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
        idType: [
          { required: true, message: '请选择证件类型', trigger: 'change' }
        ],
         idNumber: [{ required: true, message: '请输入证件号', trigger: 'blur' },
         /* {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: '请输入正确的证件号'
          },
          { validator: idCardValidity, trigger: 'blur' }*/],
        credenPhotofront: [
          { required: true, message: '请选择上传身份证正面' },
        ],
        credenPhotoback: [
          { required: true, message: '请选择上传身份证反面' },
        ],
      }
    }
  },
  components: {},
  beforeMount () {
    this.userId = this.$store.state.user.userId;
    if (this.userId === "") {
      this.userId = JSON.parse(Cookies.get("userInfo"))["userId"];
    }
    this.getImgAction();
  },
  mounted () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    // window.addEventListener("resize", this.getHeight);
    // this.getHeight();
    this.professionalQueryRealById();
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    professionalQueryRealById () {
      professionalQueryRealById(this.userId).then(res => {
        if (parseFloat(res.data.code) === 200) {
          if (res.data.data === "") {
            return;
          }
          var data = res.data.data;
          if (data != null) {
            this.ruleForm = {
              name: data.realName,
              idType: data.cardType,
              idNumber: data.cardId,
              credenPhotofront: data.cardImagePositive,
              credenPhotoback: data.cardImageBack,
            };
          }
        } else {
          this.message(res.data.msg);
        }
      });
    },
    submitAjax () {
      var this_ = this;
      var data = {
        realName: this.ruleForm.name,
        cardId: this.ruleForm.idNumber,
        cardType: this.ruleForm.idType,
        cardImagePositive: this.ruleForm.credenPhotofront,
        cardImageBack: this.ruleForm.credenPhotoback
      };
      professionalSaveRealName(data).then(res => {
        if (parseFloat(res.data.code) === 200) {
          this_.message("保存成功", 'success');
          // setTimeout(()=>{
          //     this_.$router.push("/personCenter/zizhiAuth/zizhiAuthZj_jianjie");
          // },1000);
        } else {
          this.message(res.data.msg);
        }
      });
    },

    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 赋值文件上传路径
    getImgAction () {
      let _this = this;
      // _this.imgAction = process.env.VUE_APP_BASE_API + '/device/product/uploadImg';
      _this.imgAction = baseAPI + '/device/product/uploadImg';
    },
    front_handleSuccess (res, file) {
      this.$message({
        type: 'info',
        message: '身份证人像面图片上传成功',
        duration: 6000
      });
    },
    back_handleSuccess (res, file) {
      this.$message({
        type: 'info',
        message: '身份证国徽面图片上传成功',
        duration: 6000
      });
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isGIF = file.type === 'image/gif';
      const isPNG = file.type === 'image/png';
      const isBMP = file.type === 'image/bmp';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isGIF && !isPNG && !isBMP) {
        this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    front_uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.credenPhotofront = response.data.data; //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    back_uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.credenPhotoback = response.data.data; //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
  },
}
</script>

<style scoped>
.credenPhoto {
  position: relative;
  width: 240px;
  height: 170px;
  /*border: 1px dashed #93A5BD;*/
}
.credenPhoto img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.btn-plus {
  display: block;
  margin: 0 auto;
  text-align: center;
}
.btn-plus .el-button {
  border: 2px solid #000000;
  position: relative;
}
.idbottom_Text {
  margin: 0;
  padding-top: 10px;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
  color: rgba(101, 101, 101, 1);
  line-height: 2;
}
/*img.imgsrcval{
  width: 240px;
  height: 170px;
}*/
</style>



// WEBPACK FOOTER //
// src/views/personCenter/realNameAuth.vue